








































import { Component, Prop } from "vue-property-decorator";

import { DynamicScroller, DynamicScrollerItem, RecycleScroller } from 'vue-virtual-scroller';
import CellRenderer from "@share/common/tables/j-conf-table/j-conf-cell-renderer.vue";
import BaseJConfTable from "@share/common/tables/j-conf-table/j-conf-table-base.vue";
import JConfTableHeader from "@share/common/tables/j-conf-table/header/JConfTableHeader.vue";
import {isBottom as isBottomFn} from "@common/isBottom";

import { HeaderSetting } from "../types";
import { Debounce } from "vue-debounce-decorator";

@Component({ components: { JConfTableHeader, CellRenderer, DynamicScroller, DynamicScrollerItem } })

export default class JConfTable extends BaseJConfTable {

    @Prop() items: Record<string, any>[];
    @Prop() headerSettings: HeaderSetting[];
    @Prop({ default: 'id' }) keyField: string;

    @Prop() useScrollPagination: boolean;

    mounted() {

        if(this.useScrollPagination) {
            this.getScrollElement()?.addEventListener('scroll', this.scrollhandler);
        }

        // remove 'hoverKey' prop for preventing add or remove hover class
        delete ((this.$refs.list as typeof DynamicScroller | undefined)?.$refs.scroller as typeof RecycleScroller | undefined)?.$data.hoverKey;
    }

    @Debounce(200)
    scrollhandler() {
        const isBottom = isBottomFn(this.getScrollElement() as HTMLElement);

        if(isBottom) {
            this.$emit('onBottom');
        }
    }

    click(event: any) {
        this.$emit('rowClick', event);
    }

    getScrollElement() {
        return (this.$refs.list as typeof DynamicScroller | undefined)?.$el as HTMLElement | undefined
    }

    destroyed() {
        if(this.useScrollPagination) {
            this.getScrollElement()?.removeEventListener('scroll', this.scrollhandler);
        }
    }
}
